{
  "connections": {
    "views": {
      "context": "What’s connected",
      "flow": "How we know",
      "list": "List"
    },
    "viewHints": {
      "context": "Explore services, resources, incidents, agents, policies and tools",
      "flow": "Follow knowledge from sources to lessons",
      "list": "Read links grouped by relationship"
    },
    "nearby": "{{count}} nearby record. Choose one to open it.",
    "nearby_plural": "{{count}} nearby records. Choose one to open it.",
    "nothingLinks": "Nothing links to this record yet.",
    "noneLoadedTitle": "No connections loaded",
    "noneLoadedMessage": "Refresh this record to load what it links to.",
    "emptyLinks": "Links appear here when evidence, investigations and lessons cite each other.",
    "truncated": "Showing the nearest {{count}} records. Open one to see further.",
    "thisRecord": "this record",
    "twoStepsAway": "two steps away",
    "via": "Via {{title}}",
    "linked": "Linked",
    "approvedByReviewer": "{{status}} · approved by a reviewer",
    "open": "Open {{kind}}: {{title}}",
    "stages": {
      "sources": "Sources",
      "evidence": "Evidence",
      "investigations": "Investigations",
      "lessons": "Lessons",
      "reviews": "Review",
      "usage": "Agent use",
      "context": "Entities and facts"
    },
    "stageEmpty": {
      "sources": "No source documents linked.",
      "evidence": "No evidence excerpts linked.",
      "investigations": "No investigations linked.",
      "lessons": "No lessons linked yet."
    },
    "usageRetrievals": "{{count}} search returned it in 30 days",
    "usageRetrievals_plural": "{{count}} searches returned it in 30 days",
    "usageNoFeedback": "No agent feedback yet.",
    "feedback": {
      "helpful": "Helpful",
      "not_helpful": "Not helpful",
      "wrong": "Wrong",
      "outdated": "Outdated"
    },
    "context": {
      "intro": "Services, infrastructure and agents mentioned in this record’s evidence.",
      "configuration": "Configured",
      "configurationDescription": "Relationships recorded in service selections and configuration.",
      "observed": "Observed",
      "observedDescription": "Relationships recorded in incidents and tool requests.",
      "columns": {
        "from": "From",
        "relationship": "Relationship",
        "to": "To",
        "sources": "Backed by"
      },
      "fact": "Fact",
      "evidence": "Evidence",
      "evidenceN": "Evidence {{index}}",
      "openFact": "Open the fact: {{from}} {{relationship}} {{to}}",
      "openEvidenceN": "Open evidence {{index}} for {{from}} to {{to}}",
      "emptyTitle": "No supported system links yet",
      "emptyMessage": "Links appear as connected services provide resource IDs, incident services, agent policies and tool requests. The evidence trail is available under “How we know.”",
      "caveat": "Configured links describe setup. Observed requests record decisions; they do not confirm that a tool ran. Inferred relationships are not included."
    },
    "links": {
      "basedOnThis": "Based on this",
      "evidenceBasedOn": "Evidence it is based on",
      "supportsThisLesson": "Supports this lesson",
      "lessonBasedOnThis": "Lesson based on this",
      "lessonsBasedOnIt": "Lessons based on it",
      "importedFrom": "Imported from",
      "sourceImportedFrom": "Source it was imported from",
      "importedFromThisSource": "Imported from this source",
      "investigationsImportedFromIt": "Investigations imported from it",
      "observedIn": "Observed in",
      "investigationsItCameFrom": "Investigations it came from",
      "learnedHere": "Learned here",
      "lessonsLearnedInIt": "Lessons learned in it",
      "observedHere": "Observed here",
      "evidenceObservedInIt": "Evidence observed in it",
      "excerptOf": "Excerpt of",
      "sourceItIsExcerptOf": "Source it is an excerpt of",
      "excerptFromThisSource": "Excerpt from this source",
      "excerptsTakenFromIt": "Excerpts taken from it",
      "dependsOn": "Depends on",
      "dependedOnBy": "Depended on by",
      "factAboutThis": "Fact about this",
      "factsAboutIt": "Facts about it",
      "describes": "Describes",
      "entityItDescribes": "Entity it describes",
      "cited": "Cited",
      "evidenceItCites": "Evidence it cites",
      "cameFrom": "Came from",
      "investigationItCameFrom": "Investigation it came from",
      "publishedAs": "Published as",
      "lessonItBecame": "Lesson it became",
      "incoming": "{{relation}} (incoming)",
      "reviewsOfIt": "Reviews of it",
      "twoStepsAway": "Two steps away"
    }
  },
  "evidence": {
    "whySupported": "Why this lesson is supported",
    "attached": "Attached evidence",
    "emptyTitle": "No readable evidence attached",
    "emptyMessage": "This memory does not include evidence you can read in your current scope. A proposal may need additional evidence before publication.",
    "supports": "Supports",
    "counterevidence": "Counterevidence",
    "withdrawn": "Withdrawn",
    "excerptTruncated": "Excerpt truncated",
    "localMock": "Local mock source",
    "excerptUnavailable": "Excerpt not available.",
    "collected": "Collected {{when}}",
    "viewEvidence": "View evidence",
    "viewSource": "View source",
    "openRecord": "Open",
    "latestPayload": "Latest collected payload",
    "ownPayload": "Evidence content",
    "rawToggle": "Inspect raw evidence",
    "rawShortened": "Raw preview shortened to 24,000 characters. This view contains only the supplied observation.",
    "rawFallbackToggle": "Observation content",
    "openOriginal": "Open original source",
    "providerWarning": "Provider warning: {{text}}",
    "model": {
      "timeUnavailable": "Time unavailable",
      "unitUnspecified": "Unit unspecified",
      "metricSeries": "Metric series",
      "annotation": "Annotation",
      "annotationUntil": "Until {{when}}",
      "logEvent": "Log event",
      "monitor": "Monitor",
      "observedState": "Observed state",
      "query": "Query",
      "ruleGroup": "Rule group",
      "evaluatorHealth": "Evaluator health",
      "lastError": "Last error",
      "alertInstance": "Alert instance",
      "alertInstanceValue": "{{state}} · {{labels}} · active since {{since}}",
      "unknown": "unknown",
      "outsidePreview": "Outside compared preview or absent from this export",
      "notPresent": "Not present in this export",
      "unspecified": "Unspecified",
      "valueShortened": "[Value preview shortened]"
    },
    "tabs": {
      "chart": "Chart",
      "table": "Data table",
      "timeline": "Timeline",
      "state": "State",
      "resource": "Resource",
      "mezmo": "Mezmo",
      "logs": "Logs",
      "document": "Document",
      "raw": "Raw evidence"
    },
    "metric": {
      "heading": "Metric observation",
      "window": "Observed window: {{start}} – {{end}}. Each series is shown separately; missing samples are gaps.",
      "noSeries": "The provider returned no series. This is missing evidence, not a zero value.",
      "seriesCapped": "Showing {{shown}} of {{total}} supplied series. The raw preview below has a separate display limit.",
      "oversized": "Series exceeds the display validation limit. Inspect its raw evidence.",
      "thinned": "Display thinned to {{shown}} of {{total}} samples. Values are selected samples, not averages; peaks may be omitted.",
      "invalid": "{{count}} invalid sample omitted. Lines are withheld because an invalid timestamp may hide a gap.",
      "invalid_plural": "{{count}} invalid samples omitted. Lines are withheld because an invalid timestamp may hide a gap.",
      "conflicts": "{{count}} conflicting timestamp sample retained in the table.",
      "conflicts_plural": "{{count}} conflicting timestamp samples retained in the table.",
      "noFinite": "No finite observations in this series. Missing values do not establish recovery.",
      "chartLabel": "{{label}}, {{unit}}. {{count}} observed samples. Data table follows.",
      "timeColumn": "Observed time (UTC)",
      "valueColumn": "Value ({{unit}})",
      "missing": "Missing data"
    },
    "timeline": {
      "incident": "Incident timeline",
      "annotations": "Dashboard annotations",
      "log": "Log sample",
      "incidentLabel": "Incident",
      "reportedStatus": "Reported status",
      "created": "Created",
      "resolutionCaveat": "Incident resolution does not verify application recovery.",
      "logCaveat": "A bounded log sample. It cannot establish total traffic or an error rate.",
      "service": "Service",
      "namespace": "Namespace",
      "reportedResponseTime": "Reported response time",
      "responseTimeUnit": "Response time unit",
      "bounded": "Bounded timeline: showing {{shown}} exported events of {{total}}. This is not a complete event history.",
      "boundedTruncated": "Bounded timeline: showing {{shown}} exported events; the provider export was truncated. This is not a complete event history.",
      "noEvents": "No events in this export. This does not establish that no events occurred."
    },
    "state": {
      "monitor": "Monitor state",
      "alert": "Alert rule state",
      "observedAt": "Observed at {{at}}.",
      "observedUnknown": "Observation time is unavailable.",
      "caveat": "This is one state observation; no duration or transition is inferred. The definition modification time is not the observation time.",
      "alertsTruncated": "Alert instances were truncated by the provider."
    },
    "resource": {
      "dashboard": "Dashboard definition",
      "dashboardCaveat": "Panel and query configuration; this export contains no live metric measurements.",
      "dashboardLabel": "Dashboard",
      "version": "Version",
      "updated": "Updated",
      "panel": "Panel",
      "type": "Type",
      "queries": "Query expressions",
      "panelsBounded": "Panel inventory is bounded to the supplied export and display limit.",
      "aws": "Resource configuration",
      "resource": "Resource",
      "resourceType": "Type",
      "account": "Account",
      "region": "Region",
      "configuredRelationships": "Configured relationships",
      "noRelationships": "No configured relationships recorded.",
      "relationshipsBounded": "Showing the first 80 configured relationships in this observation.",
      "relationshipsInvalid": "Some relationship entries are invalid or have an unsupported basis and could not be displayed.",
      "configurationBasis": "(configuration)",
      "awsInterpretation": "Configuration observation; runtime behavior is not verified.",
      "awsCaveat": "Configuration does not verify traffic, root cause, or recovery.",
      "kubernetes": "Resource snapshot",
      "kind": "Kind",
      "name": "Name",
      "namespace": "Namespace",
      "desiredReplicas": "Desired replicas",
      "observedReplicas": "Observed replicas",
      "readyReplicas": "Ready replicas",
      "desiredGeneration": "Desired generation",
      "observedGeneration": "Observed generation",
      "kubernetesCaveat": "Desired configuration and observed status are shown separately. A resource snapshot does not verify application recovery."
    },
    "mezmo": {
      "pattern": "Distilled log pattern",
      "changes": "Log error changes",
      "coverage": "Pattern collection coverage",
      "app": "App",
      "namespace": "Namespace",
      "from": "From",
      "until": "Until",
      "observation": "Observation",
      "thisWindow": "This window",
      "previousWindow": "Previous window",
      "events": "Events",
      "errors": "Errors",
      "countsCaption": "Counts from the selected app and namespace",
      "sourceWindow": "Source window",
      "lastSourceWrite": "Last source write",
      "resolution": "Resolution",
      "changed": "Changed",
      "patternsMatched": "Patterns matched",
      "resultsTruncated": "Results truncated",
      "yes": "Yes",
      "no": "No",
      "unknown": "Unknown",
      "bucketNote": "Counts cover whole source buckets. The requested range was {{since}} to {{until}}.",
      "historyInsufficient": "The source reports insufficient history for a reliable comparison.",
      "noObservations": "No observations in this collection. Absence does not establish service health.",
      "logCaveat": "The latest window may still be filling. Masked patterns and counts describe observed logs; they do not verify root cause or recovery.",
      "decisions": "Governance decisions",
      "agent": "Agent",
      "agentId": "Agent ID",
      "decisionsLabel": "Decisions",
      "toolRequested": "Tool requested",
      "allowed": "Allowed",
      "denied": "Denied",
      "needsApproval": "Needs approval",
      "toolsCaption": "Tool requests by policy decision",
      "toolsOmitted": "{{count}} less frequent tool is not listed.",
      "toolsOmitted_plural": "{{count}} less frequent tools are not listed.",
      "untracked": "{{count}} further tool request is counted in the decisions but not by tool.",
      "untracked_plural": "{{count}} further tool requests are counted in the decisions but not by tool.",
      "recentDecisions": "Most recent decisions ({{count}})",
      "workflow": "Workflow",
      "status": "Status",
      "tools": "Tools",
      "updated": "Updated",
      "scanTruncated": "More workflow history existed than the newest 100 workflows the collector scans, so these totals may be incomplete.",
      "consolidated": "These totals combine {{count}} decisions that earlier versions stored as one record each, from the first to the last decision shown.",
      "windowTotals": "Totals cover this collection window.",
      "approvalCaveat": "An approval lets a request through governance; it does not prove the tool ran or give the agent permission to repeat the action.",
      "toolDecision": "Agent tool decision",
      "policy": "Policy",
      "policyRevision": "Policy revision",
      "workflowStatus": "Workflow status",
      "policyDecision": "Policy decision",
      "recorded": "Recorded",
      "decision": "Decision",
      "workflowCaveat": "An approval permits this request through governance. It does not prove that the tool ran successfully or give an agent permission to repeat the action.",
      "policySummary": "Governance policy summary",
      "policyId": "Policy ID",
      "revision": "Revision",
      "fallthrough": "Fallthrough",
      "rule": "Rule",
      "toolCondition": "Tool condition",
      "inspectSource": "Inspect source",
      "policyCaveat": "Argument conditions are omitted from this summary. Inspect the original policy for its full rules. A stored policy is not a grant of execution permission.",
      "registeredAgent": "Registered governance agent",
      "name": "Name",
      "instance": "Instance",
      "registrationStatus": "Registration status",
      "runtime": "Runtime",
      "version": "Version",
      "agentCaveat": "Registration status does not verify that the agent is online.",
      "governanceCoverage": "Governance collection coverage",
      "workflowsScanned": "Workflows scanned",
      "retained": "Selected decisions retained",
      "scanLimit": "Scan limit",
      "moreHistory": "More history available",
      "coverageCaveat": "The collector scans recent account workflows and retains only the selected agents’ decisions created or updated in this window. This is a bounded history scan, not a complete inventory."
    },
    "logCollection": {
      "heading": "Log collection sample",
      "service": "Service",
      "namespace": "Namespace",
      "result": "Collection result",
      "truncated": "Truncated",
      "caveat": "This collection summary contains no traffic counts or rate measurements."
    },
    "document": {
      "heading": "Document revision",
      "shortened": "Document preview shortened to 16,000 characters."
    },
    "comparison": {
      "document": "Document changes",
      "noTextChanges": "No text changes in these revisions.",
      "changedPassage": "Changed passage beginning at line {{line}}. The blocks include any unchanged lines inside that passage.",
      "previousRevision": "Previous revision",
      "currentRevision": "Current revision",
      "noLines": "(No lines)",
      "passageBounded": "Changed passage preview limited to 120 lines and 16,000 characters per revision.",
      "state": "State observations compared",
      "stateCaveat": "Separate observations; no continuous state or transition time is inferred between them.",
      "previousObservation": "Previous observation",
      "currentObservation": "Current observation",
      "events": "Event observations compared",
      "eventsChanged": "{{count}} added or changed event in these exports. An event absent from the current bounded export is not a deletion.",
      "eventsChanged_plural": "{{count}} added or changed events in these exports. An event absent from the current bounded export is not a deletion.",
      "previousStatus": "Previous reported status",
      "currentStatus": "Current reported status",
      "eventColumn": "Event",
      "summaryColumn": "Summary",
      "eventsBounded": "Showing the first 80 event changes.",
      "fields": "Configuration fields compared",
      "fieldsCaveat": "Observed fields in these exports. A field missing from one export does not establish resource deletion. Lists are compared as complete fields.",
      "field": "Field",
      "previousExport": "Previous export",
      "currentExport": "Current export",
      "noFieldChanges": "No configuration field changes in the compared preview.",
      "fieldsBounded": "Comparison preview bounded to 160 fields and 120 changes in the supplied observations.",
      "incomparable": "These observations need separate inspection. Use the revision selector to compare their windows, labels and values; they are not combined or averaged."
    }
  },
  "observations": {
    "heading": "Observations & changes",
    "intro": "Exact collected revisions, newest first. These are observations of one source, not independent confirmations. Collection time may differ from the time of the events or samples.",
    "load": "Load observations",
    "loadHint": "Explore earlier observations without changing the evidence a lesson cited.",
    "loading": "Loading observations…",
    "loadFailed": "Observation history could not be loaded.",
    "tryAgain": "Try again",
    "historyLimited": "This bounded history may omit older observations. No inaccessible observations or totals are shown.",
    "revisionLabel": "Collected revision",
    "revisionOption": "{{when}} · version {{version}}",
    "collected": "Collected {{when}}",
    "timeNotRecorded": "Time not recorded",
    "version": "Version {{version}}",
    "localMock": "Local mock source",
    "truncatedExcerpt": "Only a shortened excerpt was stored. A complete chart or comparison cannot be drawn from it.",
    "changesTab": "Changes",
    "noPrevious": "No earlier observation on this page to compare.",
    "provenanceTab": "Provenance",
    "record": "Record",
    "sourceRevision": "Source revision",
    "empty": "No readable observations in this history.",
    "newer": "Newer observations",
    "older": "Older observations",
    "page": "Page {{page}}"
  }
}
